// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__TaxPaymentsSettingsCeo from "../../components/organisms/Taxes/PaymentsSettings/TaxPaymentsSettingsCeo.js";
import * as Buhta_cabinet__TaxPaymentsSettingsEmployees from "../../components/organisms/Taxes/PaymentsSettings/TaxPaymentsSettingsEmployees.js";
import * as Buhta_cabinet__TaxPaymentsSettingsNewEmployee from "../../components/organisms/Taxes/PaymentsSettings/TaxPaymentsSettingsNewEmployee.js";
import * as Buhta_cabinet__TaxPaymentsSettingsOrg from "../../components/organisms/Taxes/PaymentsSettings/TaxPaymentsSettingsOrg.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TaxPaymentsSettingsPage(Props) {
  let org = Props.org;
  let openMenu = Props.openMenu;
  const match = React.useState(function () {
    return 1;
  });
  const setTab = match[1];
  const tab = match[0];
  const match$1 = React.useState(function () {
    return 0;
  });
  const setTab3OpenedCount = match$1[1];
  const tab3OpenedCount = match$1[0];
  const match$2 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$2[0];
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const handleSubmit = function (ev) {
    ev.preventDefault();
    Curry._1(setTab, (function (param) {
      return tab + 1 | 0;
    }));
    if (tab === 3) {
      return Curry._1(setTab3OpenedCount, (function (param) {
        return tab3OpenedCount + 1 | 0;
      }));
    }
    
  };
  const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Tax */ 4,
      _0: {
        TAG: /* Payments */ 0,
        _0: {
          TAG: /* Orders */ 0,
          _0: /* Index */ 0
        }
      }
    }),
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/back-arrow.svg")
    })
  });
  let title;
  switch (tab) {
    case 1 :
      title = "Информация о предприятии";
      break;
    case 2 :
      title = "Информация о руководителе";
      break;
    case 3 :
      title = "Информация о сотрудниках";
      break;
    case 4 :
      title = "Новый сотрудник";
      break;
    default:
      title = "";
  }
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: title,
      leftChildren: backButton,
      openMenu: openMenu
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: title,
      route: contextRoute({
        TAG: /* Tax */ 4,
        _0: {
          TAG: /* Payments */ 0,
          _0: /* Index */ 0
        }
      })
    });
  let tmp;
  switch (tab) {
    case 1 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsSettingsOrg.make, {
        org: org,
        onSuccess: (function (param) {
          Curry._1(setTab, (function (param) {
            return tab + 1 | 0;
          }));
        })
      });
      break;
    case 2 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsSettingsCeo.make, {
        goToPrevious: (function (param) {
          Curry._1(setTab, (function (param) {
            return tab - 1 | 0;
          }));
        }),
        goToNext: handleSubmit
      });
      break;
    case 3 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsSettingsEmployees.make, {
        goToPrevious: (function (param) {
          Curry._1(setTab, (function (param) {
            return tab - 1 | 0;
          }));
        }),
        goToNext: handleSubmit
      });
      break;
    case 4 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsSettingsNewEmployee.make, {
        goToPrevious: (function (param) {
          Curry._1(setTab, (function (param) {
            return tab - 1 | 0;
          }));
        })
      });
      break;
    default:
      tmp = null;
  }
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: tmp,
    className: "bg-gray-pale px-4 py-6 md:py-10 md:px-0 flex-col items-center"
  });
}

const make = TaxPaymentsSettingsPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
